import { ArrowUpRight, BookOpen, MessageSquare, Users } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import SectionKicker from "@/components/SectionKicker";

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <section className="relative overflow-hidden pt-32 pb-14 md:pt-52 md:pb-24">
        <div className="tech-grid grid-fade absolute inset-0 opacity-40" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal><SectionKicker index="[ 04 ]">Careers</SectionKicker></Reveal>
          <Reveal delay={0.1} variant="mask">
            <h1 className="mt-6 max-w-5xl font-heading font-black uppercase tracking-normal text-5xl md:text-7xl lg:text-8xl text-white leading-[0.9]">
              Careers at<br /><span className="text-cyan-accent">KedByte.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-zinc-400 text-lg leading-relaxed">
              Get to know the studio and explore what we build and share.
            </p>
          </Reveal>
        </div>
      </section>

      <section aria-labelledby="careers-status" className="pb-20 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="rounded-2xl border border-white/10 bg-surface p-8 md:p-12">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-accent">Current openings</p>
              <h2 id="careers-status" className="mt-5 font-heading text-3xl md:text-5xl text-white tracking-normal">No current openings listed.</h2>
              <p className="mt-5 max-w-2xl text-zinc-400 leading-relaxed">
                There are no active job or internship listings on this page.
                For general questions about working with KedByte, you can contact us.
                This is not an application for an advertised role.
              </p>
              <Link to="/contact" data-testid="careers-contact" className="mt-8 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-[#050505] transition-colors hover:bg-zinc-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-accent">
                <MessageSquare className="h-4 w-4" aria-hidden="true" /> General enquiry <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section aria-labelledby="careers-explore" className="border-t border-white/10 py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal><h2 id="careers-explore" className="font-heading text-3xl md:text-5xl text-white tracking-normal">Explore KedByte.</h2></Reveal>
          <div className="mt-10 grid gap-6 md:grid-cols-2">
            <Reveal>
              <Link to="/about" className="group block h-full rounded-2xl border border-white/10 p-8 transition-colors hover:border-cyan-accent/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-accent">
                <Users className="h-5 w-5 text-cyan-accent" aria-hidden="true" />
                <h3 className="mt-6 flex items-center justify-between gap-4 font-heading text-2xl text-white">Meet the studio <ArrowUpRight className="h-5 w-5" aria-hidden="true" /></h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">Read about KedByte and our approach to software.</p>
              </Link>
            </Reveal>
            <Reveal delay={0.1}>
              <a href="/library/" className="group block h-full rounded-2xl border border-white/10 p-8 transition-colors hover:border-cyan-accent/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-accent">
                <BookOpen className="h-5 w-5 text-cyan-accent" aria-hidden="true" />
                <h3 className="mt-6 flex items-center justify-between gap-4 font-heading text-2xl text-white">Explore the Library <ArrowUpRight className="h-5 w-5" aria-hidden="true" /></h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">Browse our books and read online, at your own pace.</p>
              </a>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
